import { Component, Inject, OnDestroy, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/@store/app.reducers';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { combineLatest, Subscription } from 'rxjs';
import { selectDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { ConsultaSiniestroOutput, ConsultaEstimacionesOutput } from 'src/app/models/complementos-web/complementos-web.model';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { DetalleTablaCoberturasSiniestroResumenComponent } from '../../@components/detalle-tabla-coberturas-siniestro-resumen/detalle-tabla-coberturas-siniestro-resumen.component';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-seccion-estimaciones-siniestro',
    templateUrl: './seccion-estimaciones-siniestro.component.html',
    styleUrls: ['./seccion-estimaciones-siniestro.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, DetalleTablaCoberturasSiniestroResumenComponent, MatDialogActions, MatButton]
})
export class SeccionEstimacionesSiniestroComponent implements OnDestroy {

  public listCoberturas: MatTableDataSource<any> = new MatTableDataSource([]);
  public siniestro: string;
  public detalleSeccionSiniestroComplemento: ConsultaSiniestroOutput;
  public estimacionesSiniestro: ConsultaEstimacionesOutput;
  public listaObservables = new Subscription();

  constructor(
    public dialogRef: MatDialogRef<SeccionEstimacionesSiniestroComponent>,
    private store: Store<AppState>,
    private complementoWebService: ComplementoWebService,
    private procesosComunesService: ProcesosComunesComplementoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.obtenerReduxState();
  }

  ngOnDestroy() {
    this.listaObservables.unsubscribe();
  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleSiniestro]) => {
      this.siniestro = siniestro;
      this.detalleSeccionSiniestroComplemento = detalleSiniestro?.siniestroDetalle;
      this.consultarEstimaciones(siniestro);
    });
    this.listaObservables.add(subsComplemento);
  }

  closeDialog(opcion: string) {
    if (opcion == 'Cancelar') this.dialogRef.close();
    if (opcion == 'Aceptar') this.dialogRef.close();
  }

  consultarEstimaciones(siniestro: string) {
    const siniestroFormateado = this.procesosComunesService.devolverSiniestro(siniestro);
    const request = {
      sucursal: this.detalleSeccionSiniestroComplemento.Siniestro[0].sucursalk1,
      linea: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_linea,
      producto: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_prod,
      poliza: this.detalleSeccionSiniestroComplemento.Siniestro[0].polizak1,
      endoso: this.detalleSeccionSiniestroComplemento.Siniestro[0].endosok1,
      a_emision: this.detalleSeccionSiniestroComplemento.Siniestro[0].a_emisionk,
      no_reexpedicion: this.detalleSeccionSiniestroComplemento.Siniestro[0].no_reexpedicionk,
      cve_linea_ind: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_linea_indk,
      cve_secc_gpo: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_secc_gpok,
      inciso: this.detalleSeccionSiniestroComplemento.Siniestro[0].num_incisok,
      alarma: this.detalleSeccionSiniestroComplemento.Siniestro[0].alarma,
      num_depend: this.detalleSeccionSiniestroComplemento.Siniestro[0].num_dependk,
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      tipoPerdida: this.detalleSeccionSiniestroComplemento.Siniestro[0].cve_perdida_total,
      causa: this.detalleSeccionSiniestroComplemento.Siniestro[0].causa,
      fechaSiniestro: this.detalleSeccionSiniestroComplemento.Siniestro[0].fecsini,
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaEstimaciones(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.estimacionesSiniestro = value.Resultado;
        if (value.Resultado.Coberturas.length) {
          this.listCoberturas = new MatTableDataSource(value.Resultado.Coberturas);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos de las estimaciones.' }));
      },
    })
  }

}
